import { render } from "./TargetsCollectors.vue?vue&type=template&id=e389a314"
import script from "./TargetsCollectors.vue?vue&type=script&lang=js"
export * from "./TargetsCollectors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__